/* Keep Perkstack account links on the current Hungarian storefront.
   Only these two provider containers and the exact RO account origin are in scope. */
(() => {
  'use strict';
  const hostname = window.location.hostname.toLowerCase();
  if (hostname !== 'probeauty.hu' && !hostname.endsWith('.probeauty.hu')) return;
  if (window.__pbPerkstackMarketLinksLoaded) return;
  window.__pbPerkstackMarketLinksLoaded = true;

  const roots = '#perkstack-launcher-root, #perkstack-launcher-modal';
  const rewrite = (anchor) => {
    if (!anchor.matches?.('a[href]') || !anchor.closest(roots)) return;
    const raw = anchor.getAttribute('href').trim();
    // Check the authority before URL parsing: URL normalizes away default :443.
    const authority = raw.match(/^https:\/\/([^/?#]+)(?=\/|$|[?#])/i);
    if (!authority || authority[1].toLowerCase() !== 'probeauty.ro') return;
    let destination;
    try { destination = new URL(raw); } catch (_) { return; }
    if (destination.protocol !== 'https:' || destination.origin !== 'https://probeauty.ro' ||
        destination.username || destination.password || destination.port ||
        !destination.pathname.startsWith('/account/')) return;
    // Keep the source query and hash verbatim, including empty ? or # delimiters.
    const suffixAt = raw.search(/[?#]/);
    const suffix = suffixAt < 0 ? '' : raw.slice(suffixAt);
    const relative = destination.pathname + suffix;
    if (anchor.getAttribute('href') !== relative) anchor.setAttribute('href', relative);
  };

  const scanContainer = (container) => container.querySelectorAll('a[href]').forEach(rewrite);
  const scanAddedNode = (node) => {
    if (node.nodeType !== 1 && node.nodeType !== 11) return;
    if (node.matches?.(roots)) {
      scanContainer(node);
      return;
    }
    if (node.closest?.(roots)) {
      rewrite(node);
      node.querySelectorAll?.('a[href]').forEach(rewrite);
      return;
    }
    // A provider root may arrive inside a newly inserted wrapper.
    node.querySelectorAll?.(roots).forEach(scanContainer);
  };

  const start = () => {
    if (!document.body) return;
    document.querySelectorAll(roots).forEach(scanContainer);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') rewrite(record.target);
        else for (const node of record.addedNodes) scanAddedNode(node);
      }
    });
    observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
